<template lang="pug">
    el-dialog(title="删除队员",:fullscreen="false",:visible.sync="visible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                            el-col(:span='2')
                    div
                        el-table(ref="leftDataMemberDelete" row-key="id" v-el-table-infinite-scroll="currentChangeHandleLeftMemberDelete" :data="leftDataMemberDelete" border  @selection-change="checkLeftMemberDeleteAll" max-height="300" )
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(prop="isSixth" label="第六人" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.isSixth === 0") 否
                                    font(v-if="scope.row.isSixth === 1") 是
                            el-table-column(type="selection" align='center' reserve-selection=true)
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的人员
                    div
                        el-table(:data="rightDataMemberDelete" border max-height="317")
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(prop="isSixth" label="第六人" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.isSixth === 0") 否
                                    font(v-if="scope.row.isSixth === 1") 是
                            el-table-column(fixed="right" label="操作" align='center')
                                template(slot-scope="scope")
                                    i(class="el-icon-error" style='color:#f56c6c;cursor:pointer;font-size: 18px;' @click.prevent="deleteRowLeftMemberDelete(scope.$index, rightDataMemberDelete)")
        span.dialog-footer(slot="footer")
            el-button(@click="deleteEnrollClubMember" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
        visible: false,
        memberName: '',
        selectEnrollData: {},
        pageIndexLeftMemberDelete: 1,
        pageSizeLeftMemberDelete: 10,
        totalPageLeftMemberDelete: 0,
        leftDataMemberDelete: [], //删除队员左侧列表
        rightDataMemberDelete: [], //删除队员右侧列表
        enrollMember: {},
        ruleForm: {}
    }
  },
  methods: {
    openFullScreen () {
        this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    },
    //删除队员
    init (row, ruleForm) {
        this.visible = true
        this.selectEnrollData = row
        if (ruleForm) {
            this.ruleForm = ruleForm
        }
        this.memberName = ''
        this.pageIndexLeftMemberDelete = 1
        this.leftDataMemberDelete = []
        this.rightDataMemberDelete = []
        this.enrollMember = {}
        this.getLeftDataMemberDelete()
    },
    //删除队员左侧列表加载
    getLeftDataMemberDelete () {
        this.enrollMember.ctId = this.ruleForm.id
        this.enrollMember.id = this.selectEnrollData.id
        this.$http({
            url: this.$http.adornUrl(`/mbMember/getEnrollClubMemberList`),
            method: 'GET',
            params: this.$http.adornParams({
                'enrollId': this.selectEnrollData.id
            })
        }).then(data => {
            console.log(data)
            if (data && data.code === 0) {
                let arr = data.list.filter(item => {
                                return item.teamLeader != 1
                            })
                this.leftDataMemberDelete = arr
                if (data.sixMan && data.sixMan.length > 0) {
                    this.leftDataMemberDelete.push(data.sixMan[0])
                    console.log('俱乐部已报名的队员：', this.leftDataMemberDelete)
                    console.log('俱乐部第六人：', data.sixMan[0])
                }
                this.$refs.leftDataMemberDelete.clearSelection()
            }
        })
    },
    checkLeftMemberDeleteAll (val) {
        this.rightDataMemberDelete = val
    },
    // 每页数
    sizeChangeHandleLeftMemberDelete (val) {
        this.pageSizeLeftMemberDelete = 10
        this.pageIndexLeftMemberDelete = 1
        this.getLeftDataMemberDelete()
    },
    // 当前页
    currentChangeHandleLeftMemberDelete (val) {
        let flag = true
        if (this.pageIndexLeftMemberDelete) {
            if (this.pageIndexLeftMemberDelete < Math.ceil(this.pageIndexLeftMemberDelete / this.pageSizeLeftMemberDelete)) {
                this.pageIndexLeftMemberDelete++
            } else {
                flag = false
            }
        } else {
            this.pageIndexLeftMemberDelete = 1
        }
        if (flag) {
            this.getLeftDataMemberDelete()
        }
    },
    deleteRowLeftMemberDelete (index, rows) {
        this.$refs.leftDataMemberDelete.toggleRowSelection(rows[index], false)
        rows.splice(index, 1)
    },
    //删除俱乐部参赛会员
    deleteEnrollClubMember () {
        if (this.rightDataMemberDelete.length === 0) {
            this.$message.error('请选择要删除的人员!')
        } else if (this.rightDataMemberDelete.length > 0) {
            console.log('要提交删除的队员信息：', this.rightDataMemberDelete)
            this.enrollMember.ctId = this.ruleForm.id
            this.enrollMember.mbMemberList = this.rightDataMemberDelete

            this.openFullScreen()
            this.$http({
                url: this.$http.adornUrl(`/elEnroll/deleteEnrollClubMember`),
                method: 'post',
                data: this.enrollMember
            }).then(data => {
                console.log(data)
                if (data && data.code === 0) {
                    if (!data.state) {
                        this.$message.error(data.info)
                    } else {
                        this.$message.success('删除成功!')
                        this.visible = false
                        this.rightDataMemberDelete = []
                        this.$emit('refreshDataList')
                    }
                } else {
                    this.$message.success('删除失败!')
                }
                this.loading.close()
            })
        }
    },
    closeForm () {
        this.visible = false
    }

  }
}
</script>
